import { render, staticRenderFns } from "./ProductCard-v1.vue?vue&type=template&id=5663f1a7&scoped=true&"
import script from "./ProductCard-v1.vue?vue&type=script&lang=js&"
export * from "./ProductCard-v1.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard-v1.vue?vue&type=style&index=0&id=5663f1a7&prod&scoped=true&lang=less&"
import style1 from "./ProductCard-v1.vue?vue&type=style&index=1&id=5663f1a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663f1a7",
  null
  
)

export default component.exports